"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberByteMax = void 0;
const numberByteMax = (byteCount) => {
    return Math.pow(2, byteCount * 8) - 1;
};
exports.numberByteMax = numberByteMax;
